import React from "react"

const DIRECTION_LABEL = {
  incoming: "Incoming",
  outgoing: "Outgoing",
  missed: "Missed",
  not_picked: "Not picked",
}

const DIRECTION_COLOR = {
  incoming: "#198754",
  outgoing: "#0d6efd",
  missed: "#fd7e14",
  not_picked: "#6c757d",
}

/** Format any datetime string to e.g. 11:45AM / 12:09PM */
export const toAmPmTime = value => {
  if (!value) return "—"
  const raw = String(value)

  const m12 = raw.match(/(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)/i)
  if (m12) {
    const h = parseInt(m12[1], 10)
    const min = m12[2]
    const ap = m12[3].toUpperCase()
    return `${h}:${min}${ap}`
  }

  const m24 = raw.match(/(\d{1,2}):(\d{2})(?::\d{2})?/)
  if (!m24) return "—"

  let h = parseInt(m24[1], 10)
  const min = m24[2]
  const ap = h >= 12 ? "PM" : "AM"
  h = h % 12
  if (h === 0) h = 12
  return `${h}:${min}${ap}`
}

export const callTimeOnly = value => toAmPmTime(value)

export const updateTimeOnly = raw => toAmPmTime(raw)

const CallMetaBox = ({ call, updateAt, title }) => {
  if (!call) return null
  const direction = call.direction || ""
  const label = DIRECTION_LABEL[direction] || direction || "Call"
  const color = DIRECTION_COLOR[direction] || "#6c757d"

  return (
    <div
      className="mt-2"
      style={{
        background: "#f0f7ff",
        border: "1px solid #b8d4f0",
        borderLeft: `3px solid ${color}`,
        borderRadius: "4px",
        padding: "5px 10px",
        fontSize: "0.82em",
        color: "#334155",
        lineHeight: 1.45,
      }}
    >
      {title ? (
        <div style={{ fontWeight: 600, color: "#64748b", marginBottom: 2 }}>
          {title}
        </div>
      ) : null}
      <div>
        <span
          className="badge me-1"
          style={{
            backgroundColor: color,
            fontSize: "0.75em",
          }}
        >
          {label}
        </span>
        <span style={{ fontWeight: 600 }}>
          {call.duration_formatted || "00:00:00"}
        </span>
      </div>
      <div>
        CallTime:{" "}
        {callTimeOnly(
          call.disconnected_at || call.ended_at || call.started_at
        )}
        <span className="mx-1">|</span>
        Updated: {updateAt ? updateTimeOnly(updateAt) : "—"}
      </div>
    </div>
  )
}

export const RelatedCallBlock = ({ call, updateAt }) => (
  <CallMetaBox call={call} updateAt={updateAt} />
)

export const PreviousCallBlock = ({ call }) => (
  <CallMetaBox call={call} updateAt={call?.followup_updated_at} />
)

export default CallMetaBox
